package com.example.mystybag.sharedmodels.project.responseModels.reservations

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import com.example.mystybag.sharedmodels.project.database.UserReservationModel
import kotlinx.serialization.Serializable

@Serializable
data class GetUserReservationsResponseModel(
    val reservationsList: List<UserReservationModel> = emptyList()
) : BaseResponseModel()